import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "0",
    A_PostDt: new Date(),
    A_RefDt: new Date(),
    A_RefNo: "",
    A_Party: "",
    A_PartyName: "",
    A_Curr: "",
    A_Currname: "",
    A_ExRate: "1",
    A_PayMode: "CASH",
    A_Type: "Retail",
    A_Loc: "",
    A_Buyer: "", ////SalesMan
    A_Narr: "",

    A_DiscPerc: (0).toFixed(2),
    A_DiscAmt: (0).toFixed(2),
    A_Rounding: (0).toFixed(2),
    A_NetAmt: 0,
    A_LC: 0,
    A_Charges1: 0,
    A_Charges2: 0,
    A_DocStat: "ENTER",
    A_CUSTFIELD1: "",
    A_CUSTFIELD3: "OTTRN001",
    A_CUSTFIELD4: "N",
    A_CUSTFIELD5: "", //-- LOading Pay ,
    A_CUSTFIELD6: "",
    A_CUSTFIELD7: "",
    A_CUSTFIELD8: "",
    A_CUSTFIELD9: "",
    A_CUSTFIELD10: "",
    A_ExciseTaxNetAmt: 0,
    PKD: "N",
    A_TaxGross: "N",
    A_Taxable: "Y",
    LDP: "N",
    A_Party_TRN: "",
    A_Br_TRN: "",
    A_GST_Type: "",
    A_NetAmt_Arabic: "",
    A_VATRefNo: "",
    A_InstantPick: "N",
  },
  SalesQuotationCheckbox: {
    UnitRateLC: false,
    LDisc: false,
    TDisc: false,
    Foc: false,
    Excise: false,
    Taxable: true,
    Narration: true,
    ItemCode:true,
    PackQty:true,
  },

  WmsInnContent: {},
};

const SliceSalesQuotation = createSlice({
  name: "SliceSalesQuotation",
  initialState: { value: initialState },

  reducers: {
    SalesQuotation_Init: (state) => {
      state.value = initialState;
    },
    Set_SalesQuotation_Checkbox: (state, action) => {
      state.value.SalesQuotationCheckbox = action.payload;
    },
    SalesQuotation_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },
    Set_SalesQuotation_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },

    Set_SalesQuotation_HeadObject_New: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_Loc = action.payload.A_Loc;
      state.value.HeadObject.A_Curr = action.payload.A_Curr;
      state.value.HeadObject.A_ExRate = action.payload.A_ExRate;
      state.value.HeadObject.A_Type = action.payload.A_Type;
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
      state.value.HeadObject.A_CUSTFIELD3 = action.payload.A_CUSTFIELD3;
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
    },

    Set_SalesQuotation_HeadObject_VocNo_Doc: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Set_SalesQuotation_HeadObject_SalesGroup_SalesMan: (state, action) => {
      state.value.HeadObject.A_Buyer = action.payload.A_Buyer;
    },
    Set_SalesQuotation_HeadObject_DocStatus: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Set_SalesQuotation_HeadObject_Party: (state, action) => {
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
    },

    Set_SalesQuotation_HeadObject_PayMode: (state, action) => {
      state.value.HeadObject.A_PayMode = action.payload.A_PayMode;
    },
  },
});

export const {
  SalesQuotation_Init,
  Set_SalesQuotation_HeadObject_Set,
  Set_SalesQuotation_HeadObject_New,
  Set_SalesQuotation_HeadObject_VocNo_Doc,
  Set_SalesQuotation_HeadObject_DrCrAccount,
  Set_SalesQuotation_HeadObject_DocStatus,
  Set_SalesQuotation_HeadObject_PayMode,
  Set_SalesQuotation_HeadObject_SalesGroup_SalesMan,
  Set_SalesQuotation_HeadObject_Party,
  SalesQuotation_HeadObject_Init,
  Set_SalesQuotation_Checkbox,
} = SliceSalesQuotation.actions;
export default SliceSalesQuotation.reducer;
